import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suggestions-modal',
  templateUrl: './suggestions-modal.component.html',
  styleUrls: ['./suggestions-modal.component.scss']
})
export class SuggestionsModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
